import { axiosInstance } from "@/lib/axiosInstance";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface BookmarkType {
  id: string;
  student_id: string;
  internship_id: string;
  internship_title: string | null;
  company_name: string | null;
  company_logo_url: string | null;
  work_mode: string | null;
  stipend: number | null;
  created_at: string;
}

// ─── Service Functions ────────────────────────────────────────────────────────

export const fetchBookmarks = async (): Promise<BookmarkType[]> => {
  const res = await axiosInstance.get("/v1/bookmarks");
  const raw = res.data;
  // Handle possible {success, data:[...]} envelope
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.data)) return raw.data;
  return [];
};

export const addBookmark = async (internshipId: string): Promise<BookmarkType> => {
  const res = await axiosInstance.post("/v1/bookmarks", {
    internship_id: internshipId,
  });
  return res.data?.data || res.data;
};

export const removeBookmark = async (bookmarkId: string): Promise<void> => {
  await axiosInstance.delete(`/v1/bookmarks/${bookmarkId}`);
};
